#import "../NoteFields.graphql"
#import "../EditHistoryFields.graphql"
#import "../us-due-diligences/UsDueDiligenceFields.graphql"

fragment CaseRecordAttachmentFields on CaseRecordAttachment {
  id
  fileName
  downloadUrl
  createdAt
}

query GetCaseRecord($caseNumber: ID, $id: ID) {
  caseRecord(caseNumber: $caseNumber, id: $id) {
    id
    description
    displayName
    caseType {
      id
      name
    }
    salesforceId
    recipientFundAccount {
      id
      currency
      fund {
        id
        name
      }
    }
    senderFundAccount {
      id
      currency
      totalWorkingBalance {
        minorUnit
        currency
      }
      totalClearedBalance {
        minorUnit
        currency
      }
      fund {
        id
        name
      }
    }
    contact {
      id
      name
    }
    senderContact {
      id
      name
    }
    legallyDonatingEntity {
      id
      name
    }
    caseStage {
      id
      name
      includeInBalances
      includeInStatements
      transactionLockedIn
    }
    senderCharity {
      id
      name
    }
    recipientCharity {
      id
      name
    }
    endUserCharity {
      id
      name
    }
    recipientCompany {
      id
      name
    }
    senderCompany {
      id
      name
    }
    submittedBy {
      id
      name
    }
    owner {
      id
      name
      user {
        avatarUrl
      }
    }
    lastModifiedBy {
      id
      name
    }
    createdBy {
      id
      name
    }
    senderAmount {
      minorUnit
      currency
    }
    recipientAmountForRollUps {
      minorUnit
      currency
    }
    fxAtTimeOfTransaction
    transactionDate
    notes
    grantUseRestrictions
    shareEmailWithCharity
    shareNameWithCharity
    highImpactAtTimeOfDeployment
    createdAt
    updatedAt
    status
    caseNumber
    senderType
    senderName
    recipientType
    recipientName
    hasSyncError
    syncErrorMessage
    grantCaseRecord {
      status
      readyForRelease
      snoozedUntil
      grantRiskLevel {
        tier
        reasons
      }
      disbursement {
        status
        chariotId
      }
      cancelledAt
      cancelledReason
      usDueDiligence {
        ...UsDueDiligenceFields
      }
      complianceChecks {
        id
        status
        name
      }
    }
    attachments {
      ...CaseRecordAttachmentFields
    }
    caseNotes {
      ...NoteFields
    }
    editHistory {
      ...EditHistoryFields
    }
  }
}
